// extracted by mini-css-extract-plugin
export default {"Dialog":"messagedialog_Dialog__HZatX","Close":"messagedialog_Close__vcTJd","Body":"messagedialog_Body__+ed1e","Title":"messagedialog_Title__pvedM","Text":"messagedialog_Text__tXzod"};